import axios from "axios";
import { API_URL } from "../config";

/**
 * Check if user has completed onboarding
 * @param {Object} user - User object from AuthContext
 * @param {string} token - Access token
 * @returns {Promise<boolean>} - True if onboarding is complete, false otherwise
 */
export async function isOnboardingComplete(user, token) {
  if (!user || !token) return false;

  try {
    const response = await axios.get(`${API_URL}/user/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const profile = response.data;
    const hasPhoneNumber = profile.phone_number && profile.phone_number.trim() !== "";

    if (user.account_type === "carrier") {
      const hasDotAuthorized = profile.dot_authorized || false;
      return hasPhoneNumber && hasDotAuthorized;
    } else if (user.account_type === "dispatcher") {
      return hasPhoneNumber;
    }

    // If no account_type set, onboarding is not complete
    return false;
  } catch (err) {
    console.error("Error checking onboarding completion:", err);
    return false;
  }
}

